
import {timer as observableTimer,  Observable } from 'rxjs';
import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { DialogService, DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})

export class AlertComponent implements OnInit {

    public showAlert:boolean=false;
    public message:string;
    public divClass:string;
    public iconClass:string;
    public iconTitleText:string;
    public iconTitleClass:string;
    public bodyClass:string;

    public showAlertMessage(timerTimimg:any, Message:any,messageType:any) {
       this.showAlert=true;
       this.message=Message;
       if(messageType=='0')
       {
            this.divClass='alert-div-success';
            this.iconClass='cvt-icon-check alert-icons-success';
            this.iconTitleText="Success"
            this.iconTitleClass="alert-title-success";
            this.bodyClass="alert-body-success";
       }
       else if(messageType=='1')
       {
            this.divClass='alert-div-warning';
            this.iconClass='cvt-icon-attentionWarning alert-icons-warning';
            this.iconTitleText="Warning";
            this.iconTitleClass="alert-title-warning";
            this.bodyClass="alert-body-warning";
       }
        else if(messageType=='2')
       {
            this.divClass='alert-div-error';
            this.iconClass='cvt-icon-error alert-icons-error';
            this.iconTitleText="Error"
            this.iconTitleClass="alert-title-error";
            this.bodyClass="alert-body-error";
           
       }
        let timer = observableTimer(timerTimimg);
                    timer.subscribe(t=> {         
                    this.showAlert=false;
            });
    }
       
  ngOnInit() {
                
  }
}

export enum EnumAlertType { Success, Warning, Error };
